export * from './atoms';
export * from './molecules';
export * from './messages';

import { ProgramAtoms } from './atoms';
import { ProgramMolecules } from './molecules';
import { ProgramMessageComponents  } from './messages';

export const ProgramComponents = [
    ...ProgramAtoms,
    ...ProgramMolecules,
    ...ProgramMessageComponents
];

export const ProgramServices = [
];